<template>
  <div class="index-modular">
    <MyHeader ref="headerModular"></MyHeader>
    <ShareRight></ShareRight>
    <router-view />

    <!-- <div class="footer-modualr"> -->
      <MyFooter></MyFooter>
    <!-- </div> -->
  </div>
</template>
<script>
import MyHeader from "../components/public/header";
import ShareRight from "../components/public/publicRight";
import MyFooter from "../components/public/footer";

export default {
  components: {
    MyHeader, ShareRight, MyFooter
  },
  data() {
    return {
      pageTextArr: [
        "您还没有登录，请先登录",
        "确定",
      ],
    }
  },
  methods: {
    /**
     * 更新用户头像和名称
     */
     updateUserInfo(){
      localStorage.removeItem("userInfo")
      this.$refs.headerModular.getUserInfo()
     },

    /**
     *  加入购物车
     * @param {*} product_id 
     * @param {*} sku_number 
     * @param {*} type 
     * @param {*} portfolio_sales_middle_id 
     * @param {*} cartNum 
     */
    addCart(product_id, sku_number, type, portfolio_sales_middle_id, cartNum) {

      let that = this;
      let addFlag = true;
      if (cartNum == 0) {
        this.$refs.headerModular.shopCartNum = 0;
      } else {

        let data = {
          product_id: product_id,
          sku_number: sku_number,
          type: type,
          portfolio_sales_middle_id: portfolio_sales_middle_id,
          cartNum: 1,//购购物车数量
          cookie:that.getCookies()
        }
        console.log('加入购物车-data', data);
        //  return
        this.$http.addCart(
          data,
          (res) => {
            if (res.ret == 1) {
              this.$message.success(res.msg);
              addFlag = true;
              that.getCartNum();
              // this.$refs.headerModular.shopCartNum ++;
            } else {
              addFlag = false;
              this.$message.error(res.msg);
            }
          },
          (res) => {
            addFlag = false;
            this.$message.error(res.msg);
          }
        )
      }

      return addFlag
    },
    /**
      * 
      * @param {*} id 
      * @param {*} type 0-加入收藏 1-取消收藏
      */
    productCollect(id, type, callback) {
      let that = this;
      let data = {
        product_id: id
      }
      let status = false;
      let collectAjaxUrl = this.$http.addCollect;
      if (type == 0) {
        // 加入收藏
        collectAjaxUrl = this.$http.addCollect;
      } else {
        // 取消收藏
        collectAjaxUrl = this.$http.cancelCollect;
      }
      collectAjaxUrl(
        data, callback, callback
      )
    },


    /**
     * 获取购物车的数量
     */
    getCartNum() {
      let that = this;
      let status = false;
      // if (localStorage.getItem('isLogin') != 1) return
      this.$http.getCartNum(
        {
          cookie:that.getCookies()
        },
        (res) => {
          if (res.ret == 1) {
            this.$refs.headerModular.shopCartNum = (parseInt(res.data.cartCount))
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      )
      return status
    },

      /**
     * 提示登录
     */
     tipsLogin() {
      if (localStorage.getItem("isLogin") != 1) {
        this.$alert(this.pageTextArr[0], "", {
          distinguishCancelAndClose: true,
          confirmButtonText: this.pageTextArr[1],
        })
          .then(() => {
            this.$router.push({
              path: "/login",
            });
          })
          .catch((action) => {
            //
          });
        return true;
      }
    },

        /**
     * 语言翻译 - 单个
     * @param {*} text
     * @param {*} callback
     * @param {*} errCallBack
     */
     translate(text, callback, errCallBack) {
      let that = this;
      let data = {
        text: text, //带翻译文本
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translate(data, callback, errCallBack);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     * @param {*} callback
     * @param {*} errCallBack
     */
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

  },
  mounted() {
    let that = this;

    // 查询购物车数量
    that.getCartNum();
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/view/indexNoMenu.vue